import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { useToolCardById } from './stickerCardMapping';
import { ActionStickerCardSection, HomePageSection } from './useGetHomePageSections';

const BUILD_STRONG_PROFILE_STRINGS = appStrings.modules.home.sections.upYourGame.buildStrongProfile;
const EXPLORE_CAREER_STRINGS = appStrings.modules.home.sections.upYourGame.exploreCareers;
const BUILD_SOCIAL_CAPITAL_STRINGS = appStrings.modules.home.sections.upYourGame.buildSocialCapital;

export const BUILD_STRONG_PROFILE_SECTION = ({
  navigate,
}: HomePageSection): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: BUILD_STRONG_PROFILE_STRINGS.title,
    description: BUILD_STRONG_PROFILE_STRINGS.description,
    actionStickerCards: [
      getStickerCard('resume_optimizer'),
      getStickerCard('majors_and_courses'),
      getStickerCard('studying'),
      getStickerCard('boost_your_profile'),
    ],
  };
};

export const EXPLORE_CAREER_SECTION = ({ navigate }: HomePageSection): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: EXPLORE_CAREER_STRINGS.title,
    description: EXPLORE_CAREER_STRINGS.description,
    actionStickerCards: [
      getStickerCard('tracks_to_succeed'),
      getStickerCard('shadowing'),
      getStickerCard('jobs_paths_for_you'),
      getStickerCard('success_decoded'),
    ],
  };
};

export const BUILD_SOCIAL_CAPITAL_SECTION = ({
  navigate,
}: HomePageSection): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: BUILD_SOCIAL_CAPITAL_STRINGS.title,
    description: BUILD_SOCIAL_CAPITAL_STRINGS.description,
    actionStickerCards: [
      getStickerCard('networking'),
      getStickerCard('common_threads'),
      getStickerCard('seek_support'),
      getStickerCard('engage_teachers'),
    ],
  };
};
